import React from "react";
import { lazy } from "react";
import FilterBlock from "../../components/FilterBlock";
import { useDispatch, useSelector } from "react-redux";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { useEffect } from "react";
import { fetchGymData } from "../../data/APIs";
import { ACCOUNT_OPT } from "../../data/Constants";
import LightTable from "../../components/components-bootstrap/LightTable";
import PaginationLight from "../../components/components-bootstrap/PaginationLight";
import Loader from "../../components/ui/Loader";
import { selectAuth, selectToken } from "../../components/auth/auth.selector";
import ModalHeader from "../../components/ModalHeader.jsx";
import { useState } from "react";
import { useGetFetch, useUpdateFetch } from "../../data/Queries";
import { formatDate, normaliseString } from "../../utils/utilityfunc";
import { userDelete, userGet, usersGetKey } from "../../data/ApiEndpoints";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import SelectExportables from "../../components/common-components/SelectExportables";
import { tvOptions } from "../../components/common-data/DropdowData";
import HelmetWrapper from "../../HelmetWrapper.js";
import { isDev } from "../../components/common-data/Commons.js";
import {
  IS_USER_ADD_BY_EMAIL,
  isMemberDeleteEmail,
} from "../../components/common-data/Accessibles.js";

const UsersForm = lazy(() => import("../../components/users/UsersForm"));

const Users = () => {
  const token = useSelector(selectToken);
  const dipatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const gymData = useSelector(selectGymData);

  const isAdmin = user?.account_type === "admin";
  const isClusterManager = user?.account_type === "cluster_manager";
  const isDeleteAllowed = isDev || isMemberDeleteEmail(user?.email);
  const isUserAddAllowed = isDev || isAdmin || isClusterManager || IS_USER_ADD_BY_EMAIL(user?.email);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const initialDateFilters = {
    start_date: "",
    end_date: "",
  };
  const [dateFilters, setDateFilters] = useState(initialDateFilters);
  const [exportModal, setExportModal] = useState(false);
  const exportableData = [
    "name",
    "mobile",
    "email",
    "gym_id",
    "account_type",
    "register_type",
    "date_added",
    "status",
    "is_tv",
  ];

  const { mutateAsync: deleteUser, isLoading: isLoadingDelete } =
    useUpdateFetch({
      url: userDelete,
      key: usersGetKey,
      token,
    });

  const iniModalData = {
    status: false,
    data: null,
  };
  const [viewAllModal, setViewAllModal] = useState(iniModalData);

  const [usersFilters, setUsersFilters] = useState({
    gym_id: !isAdmin ? user?.gym_id || user?.uid || user?.user_id : "",
  });
  const [isPage, setIsPage] = useState(0);
  const {
    data: usersData,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
    refetch: refetchUsers,
  } = useGetFetch({
    url: userGet,
    key: usersGetKey,
    filters: { ...usersFilters, limit: 10, is_web: "1" },
    isPage: isPage + 1,
    token,
  });

  const allFilters = [
    {
      id: 0,
      label: "Gym",
      name: "gym_id",
      options: [...gymData, { label: "NA", value: "na" }],
    },
    {
      id: 1,
      label: "Account Type",
      name: "keyword",
      options: ACCOUNT_OPT,
    },
    {
      id: 2,
      label: "Status",
      name: "status",
      options: [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
      ],
    },
    {
      id: 3,
      label: "Created From",
      name: "register_type",
      options: [
        { label: "Mobile", value: "mobile" },
        { label: "Web", value: "web" },
      ],
    },
    {
      id: 4,
      label: "Is TV",
      name: "is_tv",
      options: tvOptions,
    },
  ];

  const col = [
    // {
    //   dataField: "uid",
    //   text: "ID",
    //   formatter: (ID) => {
    //     return (
    //       <div className="flex-k">
    //         <span>{ID}</span>
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "name",
      text: "User Details",
      formatter: (name, row) => {
        return (
          <div className="flex-k flex-col-k items-start-k">
            <span className="fs-small-k bold-text">{name}</span>
            <span className="fs-smaller-k">{row?.email}</span>
            <span className="fs-smaller-k">{row?.mobile}</span>
            <span
              className="fs-smaller-k"
              style={{ color: "lightgrey", fontSize: "10px" }}
            >
              {row?.uid}
            </span>
          </div>
        );
      },
    },
    // {
    //   dataField: "reporting_to",
    //   text: "Reporting To",
    //   formatter: (reporting_to) => {
    //     return (
    //       <div className="flex-k">
    //         <span>{reporting_to || "N/A"}</span>
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (gym) => {
        return (
          <div
            style={{
              maxWidth: "300px",
            }}
            className="flex-k gym-container"
          >
            <span>{gym || "N/A"}</span>
          </div>
        );
      },
    },
    {
      dataField: "account_type",
      text: "Account Type",
      formatter: (type) => {
        return (
          <span className="capitalise-k">{normaliseString(type) || "N/A"}</span>
        );
      },
    },
    {
      dataField: "register_type",
      text: "Created From",
      formatter: (type) => {
        return <span className="capitalise-k">{type || "N/A"}</span>;
      },
    },
    {
      dataField: "last_login",
      text: "Last Login",
      formatter: (date) => {
        return (
          <span>
            {date ? formatDate(new Date(Number(date)) * 1000) : "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "last_seen",
      text: "Last Seen",
      formatter: (date) => {
        return (
          <span>
            {date ? formatDate(new Date(Number(date)) * 1000) : "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (date) => {
        return (
          <div className="flex-k">
            <span>
              {date ? formatDate(new Date(Number(date)) * 1000) : "N/A"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (status) => {
        const isActive = status === "active";
        return (
          <div className="flex-k">
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "is_tv",
      text: "Is TV",
      formatter: (is_tv) => {
        const isActive = is_tv === 1;
        return (
          <div className="flex-k">
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {is_tv ? "Yes" : "No"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="flex-k gap-05-k">
            {isUserAddAllowed && (
              <button
                className="btn-k btn-muted-k small"
                onClick={() => setViewAllModal({ status: true, data: row })}
              >
                Edit
              </button>
            )}

            {isDeleteAllowed && (
              <button
                className="btn-k btn-muted-k small"
                disabled={isLoadingDelete}
                onClick={async () => {
                  try {
                    if (
                      window.confirm("Do you really want to delete this user?")
                    ) {
                      const { status, message } = await deleteUser({
                        data: {
                          uid: row?.uid,
                        },
                      });
                      if (status) {
                        toast.success(message);
                      } else {
                        toast.error(message);
                      }
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Delete
              </button>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    try {
      dipatch(fetchGymData(token));
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    try {
      refetchUsers();
    } catch (error) {
      console.log(error);
    }
  }, [usersFilters, isPage]);

  function isLoading() {
    try {
      if (isLoadingUsers || isFetchingUsers) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <HelmetWrapper title="WTF: Manage Users">
      <main className="cloud-bg-k">
        <div className="p-3 filterBlockContainer">
          <header className="flex-k py-2 items-end-k js-between-k">
            <h3 className="mb-0">Users</h3>

            <div className="flexEnd">
              {isUserAddAllowed && (
                <button
                  onClick={() => setIsAddModalOpen(true)}
                  className="btn-k btn-primary-k"
                >
                  Add User
                </button>
              )}
              <button
                onClick={() => setExportModal(true)}
                className="btn-k btn-primary-k"
              >
                Export User Data
              </button>
            </div>
          </header>

          <div>
            <FilterBlock
              isSearch={{
                placeholder: "Search by Name..",
              }}
              allFilters={allFilters}
              setFilters={(newFilters) => {
                try {
                  setIsPage(0);
                  return setUsersFilters(newFilters);
                } catch (error) {
                  console.log(error);
                }
              }}
              isDateRanger={{
                key: "date_ranger",
                dateFilters: dateFilters,
                setDateFilters: setDateFilters,
              }}
            />
          </div>

          <div>
            {isLoading() ? (
              <div className="flex-k js-center-k items-center-k my-6-k">
                <Loader />
              </div>
            ) : usersData && usersData?.data && !usersData?.data?.length ? (
              <div className="flex-k js-center-k items-center-k my-6-k">
                <h5 className="bold-text dark-text">No Data Available!</h5>
              </div>
            ) : (
              <>
                <LightTable columns={col} data={usersData?.data || []} />
                <div className="flex-k">
                  <PaginationLight
                    isPage={isPage}
                    onChangePage={setIsPage}
                    pagination={usersData?.pagination || []}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <ReactModal
          ariaHideApp={false}
          isOpen={isAddModalOpen}
          onRequestClose={() => setIsAddModalOpen(false)}
        >
          <div className="modal-body-k small rounded-5 bg-white">
            <ModalHeader
              title={"Add User"}
              onClick={() => setIsAddModalOpen(false)}
            />
            <div>
              <UsersForm onClose={() => setIsAddModalOpen(false)} />
            </div>
          </div>
        </ReactModal>

        <ReactModal
          ariaHideApp={false}
          isOpen={viewAllModal?.status}
          onRequestClose={() => setViewAllModal(iniModalData)}
        >
          <div className="modal-body-k small rounded-5 bg-white">
            <ModalHeader
              title={"Edit User"}
              onClick={() =>
                setViewAllModal({
                  status: false,
                  data: null,
                })
              }
            />
            <div>
              <UsersForm
                initialData={viewAllModal?.data}
                onClose={() => setViewAllModal(iniModalData)}
              />
            </div>
          </div>
        </ReactModal>

        <ReactModal ariaHideApp={false} isOpen={exportModal}>
          <div className="modal-body-k small rounded-5 bg-white">
            <ModalHeader
              title={"Select Fields To Export"}
              onClick={() => setExportModal(false)}
            />
            <div>
              <SelectExportables
                name={"users"}
                exportableData={exportableData}
                filters={usersFilters}
              />
            </div>
          </div>
        </ReactModal>
      </main>
    </HelmetWrapper>
  );
};

export default Users;
